module.exports = new __parcel__URL__("earthrise.06363af2.webp").toString();